<div class="flex items-center justify-between px-5 pt-4 pb-2">
    <div class="flex items-center gap-2">
        <h2 class="text-base font-bold text-gray-900 dark:text-white m-0">#{{ markout.ticketNumber }}</h2>
        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold"
              [ngClass]="{
                'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-200': markout.status === 'ACTIVE',
                'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200': markout.status === 'PENDING',
                'bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-200': markout.status === 'EXPIRING',
                'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-200': markout.status === 'EXPIRED'
              }">
            {{ markout.status }}
        </span>
    </div>
    <button mat-icon-button mat-dialog-close class="!w-8 !h-8">
        <mat-icon svgIcon="tabler_outline:x" class="icon-size-4"></mat-icon>
    </button>
</div>

<mat-dialog-content class="!px-5 !py-0">
    <div *ngIf="markout.project" class="py-3 border-b border-gray-200 dark:border-gray-700">
        <p class="text-[11px] text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-1">Project</p>
        <p class="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">{{ markout.project.name }}</p>
    </div>

    <div class="py-3 border-b border-gray-200 dark:border-gray-700">
        <div class="flex justify-between">
            <div>
                <p class="text-[11px] text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-1">Start</p>
                <p class="text-sm text-gray-900 dark:text-gray-100">{{ markout.digStartDate | luxonDate:'MMM d, yyyy' }}</p>
            </div>
            <div>
                <p class="text-[11px] text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-1">Start By</p>
                <p class="text-sm text-gray-900 dark:text-gray-100">{{ markout.startByDate | luxonDate:'MMM d, yyyy' }}</p>
            </div>
            <div>
                <p class="text-[11px] text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-1">Expires</p>
                <p class="text-sm text-gray-900 dark:text-gray-100">{{ markout.expirationDate | luxonDate:'MMM d, yyyy' }}</p>
            </div>
        </div>
    </div>

    <div class="py-3 border-b border-gray-200 dark:border-gray-700">
        <p class="text-[11px] text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-1">Location</p>
        <p class="text-sm text-gray-900 dark:text-gray-100">
            <span *ngIf="markout.address?.streetNumber">{{ markout.address.streetNumber }} </span>{{ markout.address?.street }}
        </p>
        <p class="text-sm text-gray-900 dark:text-gray-100">
            {{ markout.address?.city }}<span *ngIf="markout.address?.city && markout.address?.state">, </span>{{ markout.address?.state }} {{ markout.address?.zipCode }}
        </p>
        <p *ngIf="markout.crossStreet1" class="text-xs text-gray-500 dark:text-gray-400 mt-1">
            Cross: {{ markout.crossStreet1 }}<span *ngIf="markout.crossStreet2"> &amp; {{ markout.crossStreet2 }}</span>
        </p>
    </div>

    <div *ngIf="markout.notes" class="py-3">
        <p class="text-[11px] text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-1">Notes</p>
        <p class="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-line leading-relaxed">{{ markout.notes }}</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="!px-5 !py-3" align="end">
    <a mat-button [routerLink]="['/account/markouts', markout._id]" mat-dialog-close class="!text-xs">
        Open Full View
    </a>
</mat-dialog-actions>
